module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-3-2015.svg?v=df5bfd58";